export default [
    {
        value: "CustoElaboracaoSeminarioWorkshop",
        text: "Custo de elaboração de seminário/workshop"
    },
    {
        value: "Outros",
        text: "Outros"
    }
]